import request from '../utils/request'

//获取设备软件版本列表
export function getDeviceSwVersion(query) {
  return request({
    url: '/diagnosticdevices/getdicdevswversion',
    method: 'get',
    params: query
  })
}

//获取设备硬件平台类别列表
export function getDeviceHwPlatform(query) {
  return request({
    url: '/diagnosticdevices/getdicdevhwplatform',
    method: 'get',
    params: query
  })
}

//获取操作系统类别列表
export function getDeviceOsType(query) {
  return request({
    url: '/diagnosticdevices/getdicdevostype',
    method: 'get',
    params: query
  })
}

//获取设备状态列表
export function getDeviceStatus(query) {
  return request({
    url: '/diagnosticdevices/getdicdevstatus',
    method: 'get',
    params: query
  })
}

//获取设备列表
export function getDiagDevices(query) {
  return request({
    url: '/diagnosticdevices/getdiagdevices',
    method: 'get',
    params: query
  })
}

//根据设备唯一标识获取任务列表
export function getDeviceTasks(query) {
  return request({
    url: 'diagnosticdevices/getdevicetasks/devName111',
    method: 'get',
    params: query
  })
}

//添加设备
export function addDevice(data) {
  return request({
    url: '/diagnosticdevices/devices',
    method: 'post',
    data
  })
}

//设备详情
export function getDevice(name) {
  return request({
    url: '/diagnosticdevices/getdevice/'+name,
    method: 'get'
  })
}

//修改设备
export function editDevice(data) {
  return request({
    url: '/diagnosticdevices/devices/'+data.deviceIdentifier,
    method: 'put',
    data
  })
}

//删除设备
export function delDevice(name) {
  return request({
    url: '/diagnosticdevices/devices/'+name,
    method: 'delete'
  })
}

//查询用户选项
export function getUserOptions() {
  return request({
    url: '/diagnosticdevices/getuserslist?Page=1&Size=100000000',
    method: 'get'
  })
}

//查询组选项
export function getGroupOptions() {
  return request({
    url: '/diagnosticdevices/getgrouplist?Page=1&Size=100000000',
    method: 'get'
  })
}
